export const calculateGrace = (n: number): number =>
  Math.ceil(Math.round(n * 0.05));

export const createTooltipLabel = (
  value: number,
  format: Intl.NumberFormat,
  dataSetPrefix?: string
): string => {
  const formattedValue = format.format(value);

  const label = `${dataSetPrefix}: ${formattedValue}`;

  return label;
};
